var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgBackBlue(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 13,
    viewBox: "0 0 18 13",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M17.4995 6.00001H1.7065L6.8535 0.854006C7.0485 0.658006 7.0485 0.342006 6.8535 0.146006C6.6575 -0.0489941 6.3415 -0.0489941 6.1455 0.146006L0.1465 6.14601C0.1005 6.19201 0.0625 6.24801 0.0375 6.30901C-0.0125 6.43201 -0.0125 6.56801 0.0375 6.69101C0.0625 6.75201 0.1005 6.80801 0.1465 6.85401L6.1455 12.854C6.2435 12.951 6.3715 13 6.4995 13C6.6275 13 6.7555 12.951 6.8535 12.854C7.0485 12.658 7.0485 12.342 6.8535 12.146L1.7065 7.00001H17.4995C17.7755 7.00001 17.9995 6.77601 17.9995 6.50001C17.9995 6.22401 17.7755 6.00001 17.4995 6.00001Z",
    fill: "#0276B1"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBackBlue);
export default __webpack_public_path__ + "static/media/back-blue.a9018f73c4317739bc4b2dc53c4f74e7.svg";
export { ForwardRef as ReactComponent };